import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import UploadDocument from "../../comman/UploadDocument";
import { getAlert } from "../../services/appAlerts";
import { getCurrentUser } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { AddEditBackgroundChecks, getBcAddEditStatus, getLocalDocUploadSasUrl, loadBackgroundChecks } from "../../app/store/candidate";
import { uploadFileToBlob } from "../../services/blobUploadService";
import { getWfPhasesColor } from "../../services/appService";

const formatUSPhoneNumber = (phoneNo) => {
  if (!phoneNo) return "";
  const cleaned = ("" + phoneNo).replace(/\D/g, "");
  const match = cleaned.match(/^(1)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[2]}) ${match[3]}-${match[4]}`;
  }
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phoneNo;
};

const AddBcChecks = (props) => {
  const { bcCheckShowHide, handleBcCheckShowHide, bcType,
    candidateObj, workItem, bcObject } = props;

  const [documents, setDocuments] = useState([]);
  const [saveBtnStatus, setSaveBtnStatus] = useState(false);
  const [bcStatus, setBcStatus] = useState(null);
  const [bcNotes, setBcNotes] = useState("");
  const [bcNotifyNotes, setBcNotifyNotes] = useState("");
  const [newBcObj, setNewBcObj] = useState(null);

  const bcAddEditStatusSelector = useSelector(getBcAddEditStatus);
  const localDocUploadSasUrlSelector = useSelector(getLocalDocUploadSasUrl);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  const currentTask = workItem;
  const themeClass = "theme-primary";

  const candidateName = candidateObj?.performerName || candidateObj?.name || candidateObj?.performername || "";
  const email = candidateObj?.performeremail || candidateObj?.email || "";
  const phone = candidateObj?.contactNo || candidateObj?.companyPhone || "";

  useEffect(() => {
    if (bcObject) {
      setBcNotifyNotes(bcObject.instructionNotes);
      setBcNotes(bcObject.notes);
      setBcStatus(bcObject.status);
    }
  }, [bcObject])

  const doSubmit = async () => {
    if (bcType === "notify") {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to notify candidate!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        customClass: {
          confirmButton: 'swal2-outline-black',
          cancelButton: 'swal2-outline-red'
        },
        didOpen: () => {
          const confirmButton = Swal.getConfirmButton();
          confirmButton.innerHTML = `
                        <i class="fa fa-check" style="margin-right: 8px;"></i> Yes`;

          const cancelButton = Swal.getCancelButton();
          cancelButton.innerHTML = `
                        <i class="fa fa-times" style="margin-right: 8px; margin-left:3px;"></i> No`;
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          saveEditBackgroundCheck();
        } else {
          setSaveBtnStatus(false);
        }
      });
    } else {
      saveEditBackgroundCheck();
    }
  };

  const saveEditBackgroundCheck = async () => {
    setSaveBtnStatus(true);

    let wfTask = { ...workItem };
    if (candidateObj?.applications.length > 0)
      wfTask.parentCiid = candidateObj?.applications[0].ciid;

    let data = { ...bcObject };
    if (bcType === "new")
      data = { ...newBcObj };
    data.performerId = candidateObj.performerid;
    data.addedBy = currentUser.id;
    data.notes = bcNotes;
    if (bcType === "notify")
      data.notes = bcNotifyNotes;

    data.status = bcStatus;
    const formData = new FormData();
    formData.append("BackgroundChecks", JSON.stringify(data));
    formData.append("workflowTask", JSON.stringify(wfTask));
    formData.append("editType", bcType);
    // documents.map((file, key) =>
    //   formData.append("files[" + key + "]", file.file)
    // );
    formData.append("files", JSON.stringify(documents.map(x => ({ name: x.name, type: x.type, size: x.size }))));

    dispatch(AddEditBackgroundChecks(formData));
  };


  useEffect(() => {
    if (bcAddEditStatusSelector !== null && bcAddEditStatusSelector > -1) {
      getAlert("", "Saved Successfully", "success");
      setDocuments([]);
      setBcNotes("");
      setSaveBtnStatus(false);
      setBcNotifyNotes("");
      if (workItem?.applicantId > 0) {
        dispatch(loadBackgroundChecks(workItem.applicantId));
      }
      handleBcCheckShowHide("save", "");
    }
  }, [bcAddEditStatusSelector])

  useEffect(() => {
    if (localDocUploadSasUrlSelector && localDocUploadSasUrlSelector?.length > 0) {
      documents.map((file, key) =>
        uploadFileToBlob(file.file, localDocUploadSasUrlSelector[key]?.uploadUrl, (progress) => {
          console.log(`Upload progress: ${progress}%`);
        })
      )
    }
  }, [localDocUploadSasUrlSelector]);

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
        size: file.size,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const index = documents.indexOf(item);
    let docs = [...documents];
    if (index !== -1) {
      docs.splice(index, 1);
      setDocuments(docs)
    }
  };

  return (
    <div className={`bc-container rt-tools-modal ${themeClass}`} style={{ width: '100%', maxWidth: '100%', margin: '0 auto' }}>
      <style>{`
        /* Dynamic Theme Palette */
        .rt-tools-modal.theme-primary { --task-accent: #3b82f6; --task-soft: #eff6ff; }
        .rt-tools-modal.theme-info { --task-accent: #06b6d4; --task-soft: #ecfeff; }
        .rt-tools-modal.theme-warning { --task-accent: #f59e0b; --task-soft: #fffbeb; }
        .rt-tools-modal.theme-success { --task-accent: #22c55e; --task-soft: #f0fdf4; }
        .rt-tools-modal.theme-wf2-default { --task-accent: #eab308; --task-soft: #fef9c3; }
        .rt-tools-modal.theme-wf3-default { --task-accent: #10b981; --task-soft: #ecfdf5; }
        .rt-tools-modal.theme-wf4-default { --task-accent: #ef4444; --task-soft: #fef2f2; }
        .rt-tools-modal.theme-wf5-default { --task-accent: #f97316; --task-soft: #fff7ed; }
        .rt-tools-modal.theme-wf6-default { --task-accent: #8b5cf6; --task-soft: #f5f3ff; }
        .rt-tools-modal.theme-default,
        .rt-tools-modal.theme-wf-default { --task-accent: #64748b; --task-soft: #f8fafc; }

        /* Card Layout Styles - Flat for Tab Integration */
        .wf-form-card {
          background: #ffffff !important;
          border: none !important;
          border-radius: 0 !important;
          box-shadow: none !important;
          overflow: hidden !important;
          margin-bottom: 0 !important;
          animation: tabFadeIn 0.3s ease both !important;
        }
        .wf-form-header {
          position: relative !important;
          padding: 20px 24px !important;
          background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 18px !important;
        }
        .wf-form-header::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          bottom: 0 !important;
          width: 4px !important;
          background: var(--task-accent) !important;
        }
        .rt-header-icon {
          width: 44px !important;
          height: 44px !important;
          border-radius: 10px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: var(--task-accent) !important;
          background: #ffffff !important;
          border: 1px solid var(--task-accent) !important;
          font-size: 16px !important;
          flex-shrink: 0 !important;
          box-shadow: 0 4px 10px rgba(15, 23, 42, 0.05) !important;
        }
        .wf-form-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 16.5px !important;
          font-weight: 850 !important;
          line-height: 1.2 !important;
        }
        .wf-form-body {
          padding: 24px !important;
          background: #ffffff !important;
        }
        .wf-form-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 16px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 12px !important;
        }
        .wf-form-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 8px !important;
          min-width: 0 !important;
        }
        .wf-form-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 999px !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: var(--task-soft) !important;
          color: var(--task-accent) !important;
          border: 1px solid #e2e8f0 !important;
          margin-left: 10px !important;
        }
        .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 10px 12px !important;
          margin-top: 0 !important;
          padding-left: 0 !important;
          font-size: 12px !important;
          color: #64748b !important;
        }
        .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          background: #ffffff !important;
          padding: 5px 10px !important;
          border-radius: 8px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          border: 1px solid #e2e8f0 !important;
          box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
        }
        .rt-meta-chip i {
          color: var(--task-accent) !important;
          font-size: 11px !important;
        }

        /* Labels and Controls */
        .rt-tools-modal .wf-control-label {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          margin-bottom: 6px !important;
          display: flex !important;
          align-items: center !important;
          gap: 6px !important;
        }
        .rt-tools-modal .wf-control-label i {
          color: var(--task-accent) !important;
          font-size: 11px !important;
        }

        /* Inputs and Textareas */
        .rt-tools-modal .wf-input {
          font-size: 12px !important;
          color: #0f172a !important;
          background-color: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          padding: 8px 12px !important;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
          transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
          outline: none !important;
          width: 100% !important;
          height: auto !important;
        }
        .rt-tools-modal .wf-input:focus {
          border-color: var(--task-accent) !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1), 0 1px 2px rgba(0,0,0,0.05) !important;
          outline: none !important;
        }

        /* Status selection cards */
        .status-select-container {
            display: flex;
            gap: 16px;
            margin-top: 6px;
            margin-bottom: 16px;
            width: 100%;
        }
        .status-select-card {
            flex: 1;
            border: 2.0px solid #cbd5e1;
            border-radius: 8px;
            padding: 12px 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            font-weight: 750;
            font-size: 13.5px;
            cursor: pointer;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            background: #ffffff;
        }
        .status-select-card.pass {
            color: #16a34a;
        }
        .status-select-card.pass:hover {
            background: #f0fdf4;
            border-color: #86efac;
        }
        .status-select-card.pass.selected {
            background: #ecfdf5;
            border-color: #22c55e;
            box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15);
        }
        .status-select-card.fail {
            color: #dc2626;
        }
        .status-select-card.fail:hover {
            background: #fef2f2;
            border-color: #fca5a5;
        }
        .status-select-card.fail.selected {
            background: #fef2f2;
            border-color: #ef4444;
            box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
        }
        .status-select-card i {
            font-size: 16px;
        }

        /* Buttons matching tools */
        .rt-tools-modal .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          padding: 8px 18px !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          border-radius: 8px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
          cursor: pointer !important;
          background-color: #f1f5f9 !important;
          border: 1px solid #cbd5e1 !important;
          color: #475569 !important;
        }
        .rt-tools-modal .btn-action-search:hover {
          background-color: #e2e8f0 !important;
          color: #334155 !important;
          transform: translateY(-1px) !important;
        }
        .rt-tools-modal .btn-action-search.btn-primary-search {
          background-color: var(--task-accent) !important;
          border-color: var(--task-accent) !important;
          color: #ffffff !important;
        }
        .rt-tools-modal .btn-action-search.btn-primary-search:hover {
          opacity: 0.9 !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
          transform: translateY(-1px) !important;
        }
        .rt-tools-modal .btn-action-search:disabled {
          background-color: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
          opacity: 0.85 !important;
        }
        .rt-tools-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 9px 20px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }
        .rt-tools-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .rt-tools-modal .wf-modal-footer-close-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
        }
        .rt-tools-modal .wf-modal-footer-close-btn:hover i {
          color: var(--task-accent) !important;
        }
      `}</style>

      <div className="wf-form-card">
        <div className="wf-form-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flex: 1, minWidth: 0 }}>
            <i className="rt-header-icon fa fa-shield" aria-hidden="true" />
            <div className="wf-form-header-copy">
              <h3 className="wf-form-title">
                <span>
                  {bcType === "new" && "Add Background Check"}
                  {bcType === "edit" && "Internal Details & Notes"}
                  {bcType === "notify" && "Notify Candidate"}
                </span>
                {currentTask?.wfPhase && (
                  <span className="wf-form-title-badge">
                    {currentTask.wfPhase}
                  </span>
                )}
              </h3>
              {(candidateName || email || phone) && (
                <div className="rt-modal-meta-row">
                  {candidateName && (
                    <span className="rt-meta-chip">
                      <i className="fa fa-user" aria-hidden="true" /> {candidateName}
                    </span>
                  )}
                  {email && (
                    <span className="rt-meta-chip" title={email}>
                      <i className="fa fa-envelope" aria-hidden="true" /> {email}
                    </span>
                  )}
                  {phone && (
                    <span className="rt-meta-chip">
                      <i className="fa fa-phone" aria-hidden="true" /> {formatUSPhoneNumber(phone)}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handleBcCheckShowHide("", "")}
            title="Back"
          >
            <i className="fa fa-arrow-left" aria-hidden="true" />
            Back
          </button>
        </div>
        <div className="wf-form-body">
          <div className="row">
            {bcType === "new" && (
              <div className="col-md-12 form-group">
                <label htmlFor="name" className="wf-control-label">
                  <i className="fa fa-info-circle" aria-hidden="true" /> Background Check Name
                </label>
                <input
                  type="text"
                  className="wf-input"
                  name="name"
                  id="name"
                  value={newBcObj?.name || ""}
                  placeholder="e.g. Standard Criminal Search"
                  onChange={({ currentTarget }) => setNewBcObj({ ...newBcObj, name: currentTarget.value })}
                />
              </div>
            )}
            {(bcType === "edit" || bcType === "new") && (
              <div className="col-md-12 form-group">
                <label htmlFor="notes" className="wf-control-label">
                  <i className="fa fa-sticky-note-o" aria-hidden="true" /> Internal Notes
                </label>
                <textarea
                  rows={4}
                  className="wf-input"
                  name="notes"
                  id="notes"
                  value={bcNotes}
                  placeholder="Enter internal verification logs or updates..."
                  onChange={({ currentTarget }) => setBcNotes(currentTarget.value)}
                />
              </div>
            )}
            {bcType === "notify" && (
              <div className="col-md-12 form-group">
                <label htmlFor="notes" className="wf-control-label">
                  <i className="fa fa-paper-plane-o" aria-hidden="true" /> Notification Instruction Notes
                </label>
                <textarea
                  rows={4}
                  className="wf-input"
                  name="notes"
                  id="notes"
                  value={bcNotifyNotes}
                  placeholder="Enter instructions for the candidate..."
                  onChange={({ currentTarget }) => setBcNotifyNotes(currentTarget.value)}
                />
              </div>
            )}
            {bcType === "edit" && (
              <div className="col-md-12 form-group">
                <label className="wf-control-label">
                  <i className="fa fa-check-square-o" aria-hidden="true" /> Update Status
                </label>
                <div className="status-select-container">
                  <div
                    className={`status-select-card pass ${bcStatus === true ? 'selected' : ''}`}
                    onClick={() => setBcStatus(true)}
                  >
                    <i className="fa fa-check-circle" aria-hidden="true" />
                    <span>Passed</span>
                  </div>
                  <div
                    className={`status-select-card fail ${bcStatus === false ? 'selected' : ''}`}
                    onClick={() => setBcStatus(false)}
                  >
                    <i className="fa fa-times-circle" aria-hidden="true" />
                    <span>Failed</span>
                  </div>
                </div>
              </div>
            )}

            {(bcType === "edit" || bcType === "notify") && (
              <div className="col-md-12 mt-2">
                <label className="wf-control-label" style={{ marginBottom: '10px' }}>
                  <i className="fa fa-cloud-upload" aria-hidden="true" /> Upload Documents
                </label>
                <UploadDocument
                  documents={documents}
                  handleFileRemove={handleFileRemove}
                  onFileChange={onFileChange}
                />
              </div>
            )}
          </div>
        </div>
        <div className="wf-form-footer">
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handleBcCheckShowHide("", "")}
          >
            <i className="fa fa-arrow-left" aria-hidden="true" />
            Back
          </button>
          {(bcType !== "" || bcType === "new") && (
            <button
              type="button"
              className="btn-action-search btn-primary-search"
              disabled={saveBtnStatus}
              onClick={doSubmit}
            >
              {saveBtnStatus ? (
                <i className="fa fa-circle-o-notch fa-spin" style={{ marginRight: '8px' }} />
              ) : <i className="fa fa-check" style={{ marginRight: '8px' }} />}
              Save Changes
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddBcChecks;
